module.exports = __webpack_public_path__ + "static/segment-notifications-37a2dd5b4a776a5eff850a3edf911958.png";